import Grid from '@mui/material/Grid';
import { UseFormRegister, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import createFormTextField from '../../../../components/FormTextFields/FormTextFields';
import { getValuationMethodOptions } from '../../utils/formOptions';
import ValuationMethodDescription from './ValuationMethodDescription';

interface ValuationMethodFieldProps {
  currentValue: string;
  canEdit: boolean;
  register: UseFormRegister<FieldValues>;
}

export default function ValuationMethodField({ currentValue, canEdit, register }: ValuationMethodFieldProps) {
  const { t } = useTranslation();
  const valuationMethodOptions = getValuationMethodOptions(t);

  return (
    <Grid container pl={2} spacing={2}>
      {createFormTextField(
        {
          name: 'valuationMethod',
          variant: 'select',
          label: t('inventory.inventoryValuationSettings.valuationMethodLabel'),
          options: valuationMethodOptions,
          disabled: !canEdit,
          dataTestId: 'valuation-method-select',
          gridProps: { xs: 12, md: 4 },
        },
        { t, tKey: '' },
        register
      )}

      <Grid item xs={12} md={8}>
        <ValuationMethodDescription currentValue={currentValue} />
      </Grid>
    </Grid>
  );
}
